import ProjectDropdown, {projectDropdownQuery} from "./project_dropdown";
import ForecastQueryRenderer from "../../ForecastQueryRenderer";
import React from "react";

const projectDropdownWrapper = ({
    project,
    onChange,
    loaderComponent
}) => {

    return (
        <ForecastQueryRenderer
            key="query-render-projectDropdown"
            componentName="project_dropdown"
            query={projectDropdownQuery}
            showLoader={true}
            customLoader={() => loaderComponent}
            render={(relayProps, retry) => {
                return (
                    <ProjectDropdown
                        {...relayProps}
                        retry={retry}
                        project={project}
                        onChange={onChange}
                    />
                );
            }}
        />
    );
};

export default (projectDropdownWrapper);